module.exports = __webpack_public_path__ + "img/220.70ca17e3.png";